import { render, staticRenderFns } from "./ClientRegisterExport.vue?vue&type=template&id=d1c5b304"
import script from "./ClientRegisterExport.vue?vue&type=script&lang=js"
export * from "./ClientRegisterExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports